/**
 * Dữ liệu mẫu của màn Phân công nhiệm vụ (module `van-ban`) cho `?mock=` và `pnpm dev` không có
 * backend. Đơn vị nhận lấy từ `MOCK_DON_VI` (cùng id), như danh sách vai trò các cấp của bản mẫu.
 * Không quyết màu ở đây (CLAUDE.md): tông nằm ở `modules/xu-ly-van-ban/constants.ts`.
 */
import type { NhiemVuPhanCong } from '../modules/xu-ly-van-ban/types-phan-cong';
import { MOCK_DON_VI } from './van-ban';

const LUC = '2026-10-10T08:30:00Z';

function nhiemVu(
  so: number,
  donViSo: number,
  task_content: string,
  vanBan: string | null,
  deadline: string | null,
  status: NhiemVuPhanCong['status'],
  attachment_filename: string | null = null,
): NhiemVuPhanCong {
  const dv = MOCK_DON_VI[donViSo - 1];
  return {
    id: `66666666-${String(so).padStart(4, '0')}-0000-0000-000000000000`,
    summarization_id: vanBan ? '77777777-0001-0000-0000-000000000000' : null,
    summarization_name: vanBan,
    task_content,
    related_document: vanBan,
    attachment_filename,
    deadline,
    status,
    status_label: MOCK_CAU_PHAN_CONG.trangThai[status],
    unit_id: dv?.id ?? null,
    unit_name: dv?.name ?? null,
    unit_type: dv?.type ?? null,
    created_at: `2026-10-${String(10 + so).padStart(2, '0')}T08:30:00Z`,
    updated_at: LUC,
  };
}

/** Câu do backend trả (thông điệp lỗi, nhãn trạng thái) — dữ liệu, không qua i18n. */
export const MOCK_CAU_PHAN_CONG = {
  trangThai: {
    MOI_PHAN_CONG: 'Mới phân công',
    DANG_THUC_HIEN: 'Đang thực hiện',
    HOAN_THANH: 'Hoàn thành',
  },
  khongThay: 'Nhiệm vụ không tồn tại',
  khongCoTep: 'Nhiệm vụ không có tệp đính kèm',
  donViKhongCo: 'Đơn vị được phân công không tồn tại trong danh sách vai trò các cấp',
  daTiepNhan: 'Đã tiếp nhận file, AI đang phân công nhiệm vụ. Theo dõi qua GET /task-assignments/jobs/{job_id}.',
  daTao: (so: number, ten: string) => `AI đã tạo ${so} nhiệm vụ từ file "${ten}".`,
  daTaoTuTomTat: (so: number) =>
    `AI đã tạo ${so} nhiệm vụ từ bản tóm tắt, giao cho các phòng ban, cá nhân phù hợp.`,
  noiDungTep: 'Nội dung tệp đính kèm ở bản dữ liệu mẫu.',
  viecTuTep: 'Triển khai nội dung văn bản tải lên',
  trichDoan:
    'Kế hoạch triển khai chuyển đổi số năm 2026. Yêu cầu các phòng ban rà soát hạ tầng và báo cáo trước ngày 30/11.',
};

export const MOCK_NHIEM_VU_PHAN_CONG: NhiemVuPhanCong[] = [
  nhiemVu(1, 4, 'Rà soát hạ tầng máy chủ, đường truyền phục vụ chuyển đổi số năm 2026.', 'Kế hoạch chuyển đổi số 2026', '2026-11-30', 'DANG_THUC_HIEN', 'ke-hoach-cds-2026.pdf'),
  nhiemVu(2, 3, 'Tổng hợp báo cáo kết quả thực hiện của các đơn vị, trình lãnh đạo Sở.', 'Kế hoạch chuyển đổi số 2026', '2026-12-05', 'MOI_PHAN_CONG', 'ke-hoach-cds-2026.pdf'),
  nhiemVu(3, 8, 'Đánh giá an toàn thông tin hệ thống một cửa điện tử.', null, '2026-11-15', 'HOAN_THANH'),
  nhiemVu(4, 5, 'Xây dựng kế hoạch tuyên truyền về chuyển đổi số trên báo, đài địa phương.', 'Công văn số 125/STTTT', null, 'MOI_PHAN_CONG'),
  nhiemVu(5, 2, 'Chủ trì triển khai Kế hoạch chuyển đổi số năm 2026.', 'Kế hoạch chuyển đổi số 2026', '2026-12-31', 'DANG_THUC_HIEN'),
];
